import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthUser } from "../features/auth/types";

export interface CurrentUserState {
    data: AuthUser;
    errors: {
        [key: string]: string | undefined;
    };
}

const initialState: CurrentUserState = {
    data: {
        token: '',
        language: '',
        permissions: [],
        roles: [],
        selectedOrganizationalStructureIds: [],
        email: "",
        hasAccessToClinicalHistory: false
    },
    errors: {}
};

const currentUserSlice = createSlice({
    name: "currentUser",
    initialState,
    reducers: {
        setCurrentUser(state, action: PayloadAction<AuthUser>) {
            state.data = action.payload;
        },
        resetCurrentUser() {
            return initialState;
        },
        updateCurrentUserField(state, action: PayloadAction<{ field: keyof AuthUser; value: AuthUser[keyof AuthUser] }>) {
            const { field, value } = action.payload;
            state.data[field] = value as never;
        },
        setError(state, action: PayloadAction<{ field: keyof AuthUser | string; message: string | undefined }>) {
            const { field, message } = action.payload;
            state.errors[field] = message;
        },
        clearErrors(state) {
            state.errors = {};
        },
    }
});

export const { setCurrentUser, resetCurrentUser, updateCurrentUserField, setError, clearErrors } = currentUserSlice.actions;
export default currentUserSlice.reducer;